module.exports = __webpack_public_path__ + "static/media/canada.e62c2b36.svg";